import CloseIcon from '@mui/icons-material/Close';
import { Modal, Button, Select, SelectChangeEvent, MenuItem } from '@mui/material';
import TextField from '@mui/material/TextField';
import React, { useState, useEffect, Dispatch, SetStateAction } from 'react';

import { Notifications_Type, USER_TYPE } from '../utils/enums';

interface AddNotificationModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  handleSubmit: (data: {
    title: string;
    message: string;
    role: number | string;
    type: number | string;
  }) => void;
}

export default function AddNotification({
  open,
  onClose,
  setOpen,
  handleSubmit,
}: AddNotificationModalProps) {
  const [selectField1, setSelectField1] = React.useState('default');
  const [error, setError] = useState(false);
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  const [type, setType] = useState('default');
  const [selectAll, setSelectAll] = useState(false);

  const handleChange1 = (event: SelectChangeEvent) => {
    setSelectField1(event.target.value as string);
  };

  const handleType = (event: SelectChangeEvent) => {
    setType(event.target.value as string);
  };

  const mapUserTypeToType = (user: string) => {
    switch (user) {
      case 'Individual':
        return USER_TYPE.INDIVIDUAL;
      case 'Dealer':
        return USER_TYPE.DEALER;
      case 'Subadmin':
        return USER_TYPE.SUBADMIN;
      case 'Select All':
        return USER_TYPE.ALL;
      default:
        return 'default';
    }
  };
  const UserType = {
    Individual: '2',
    Dealer: '1',
  };
  // UserType["Dealer
  const handleSelectAllChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectAll(event.target.checked);
    if (event.target.checked) {
      setSelectField1('Select All');
    } else {
      setSelectField1('default');
    }
  };

  const handleFormSubmit = () => {
    setError(true);
    if (title === '' || message === '' || selectField1 === 'default' || type === 'default') {
      return;
    }

    const userType = mapUserTypeToType(selectField1);

    handleSubmit({
      title,
      message,
      role: userType,
      type,
    });

    setTitle('');
    setMessage('');
    setType('default');
    setSelectField1('default');
    setSelectAll(false);
    setOpen(false);
  };

  useEffect(() => {
    if (open) {
      setError(false);
    }
  }, [open]);

  return (
    <Modal
      className="modal addNotification_modal"
      id="addNotificationModal"
      aria-labelledby="addNotification-modal-title"
      aria-describedby="addNotification-modal-description"
      open={open}
      onClose={onClose}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="btn-close" onClick={() => setOpen(false)}>
            <CloseIcon />
          </div>
          <div className="modal_title">
            <h2>Add Notification</h2>
          </div>
          <form className="form" action="">
            <div className="control_group">
              <TextField
                variant="outlined"
                placeholder="Notification Title"
                fullWidth
                hiddenLabel
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                onFocus={() => setError(false)}
              />
              {error && title === '' && <h6 className="err_msg">Title is required</h6>}
            </div>
            <div className="control_group">
              <TextField
                variant="outlined"
                placeholder="Notification Message"
                fullWidth
                hiddenLabel
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                onFocus={() => setError(false)}
              />
              {error && message === '' && <h6 className="err_msg">Message is required</h6>}
            </div>
            <div className="control_group">
              <Select
                fullWidth
                value={selectField1}
                onChange={handleChange1}
                label="Select User"
                // disabled={selectAll}
              >
                <MenuItem value="default" disabled>
                  Select User
                </MenuItem>
                <MenuItem value="Individual">Individual</MenuItem>
                <MenuItem value="Dealer">Dealer</MenuItem>
                <MenuItem value="Subadmin">Subadmin</MenuItem>
                <MenuItem value="Select All">Select All</MenuItem>
              </Select>
              {error && selectField1 === 'default' && (
                <h6 className="err_msg">Select at least one user</h6>
              )}
            </div>
            <div className="control_group">
              <Select
                fullWidth
                value={type}
                onChange={handleType}
                label="Select Type"
                // disabled={selectAll}
              >
                <MenuItem value="default" disabled>
                  Select type
                </MenuItem>
                <MenuItem value={Notifications_Type.PUSH}>Push</MenuItem>
                <MenuItem value={Notifications_Type.MAIL}>Email</MenuItem>
              </Select>
              {error && type === 'default' && <h6 className="err_msg">This field is required</h6>}
            </div>
            {/* <div className="control_group">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectAll}
                    onChange={handleSelectAllChange}
                    color="primary"
                  />
                }
                label="Select All"
              />
            </div> */}
            <div className="footer_btn_flex">
              <Button
                className="btn btn_highlight"
                onClick={() => {
                  setError(false);
                  setTitle('');
                  setMessage('');
                  setType('default');
                  setSelectField1('default');
                  setSelectAll(false);
                  setOpen(false);
                }}
              >
                Cancel
              </Button>
              <Button className="btn btn_secondary" onClick={handleFormSubmit}>
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
